import { NetworkStatus } from "@apollo/client";
import { useQuery } from "@apollo/client/react";
import { useCallback, useMemo } from "react";

import { LIST_MODULE_PULL_REQUESTS } from "./gql";

const useModulePullRequests = (moduleId: string) => {
  const { data, error, loading, networkStatus, refetch } = useQuery(LIST_MODULE_PULL_REQUESTS, {
    variables: { id: moduleId },
    notifyOnNetworkStatusChange: true,
  });

  const pullRequests = useMemo(
    () => data?.module?.pullRequests ?? [],
    [data?.module?.pullRequests]
  );

  const refresh = useCallback(() => refetch(), [refetch]);

  return {
    pullRequests,
    error,
    isPageLoading: loading && !data?.module,
    isRefreshing: networkStatus === NetworkStatus.refetch,
    isEmpty: pullRequests.length === 0,
    isNotFound: !loading && !data?.module,
    refresh,
  };
};

export default useModulePullRequests;
